import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {head, map} from 'lodash';

import Button from 'components/Button';
import RecommendationAnnotation from 'components/RecommendationAnnotation';
import RecommendationAnnotationTags from 'components/RecommendationAnnotation/Tags';
import Link from 'components/links/Link';
import Types, {getBaseUrl} from 'conf/types';
import {closeIcon, openIcon} from 'pages/genotypeResults/DrugResultGrid';

import 'pages/genotypeResults/DrugResultGridGenotypeResult.scss';


const makeMoreUrl = (sourceId, sourceCls, chemicals) => {
  if (sourceCls !== 'Guideline Annotation') {
    return getBaseUrl(sourceId, sourceCls);
  } else {
    return head(map(chemicals, (c) => getBaseUrl(c.id, c.objCls) + getBaseUrl(sourceId, sourceCls)));
  }
};

/**
 * A component to display a genotype result (i.e. a RecommendationAnnotation with additional data) in the context of
 * the drug result grid.
 */
export default function DrugResultGridGenotypeResult({
  id, implications = [], text, moreText, genotypes, phenotypes, lookupKey,
  classification, population = 'unspecified', alternateDrugAvailable, dosingInformation, otherPrescribingGuidance,
  open, onOpenChange, multiPopulation = false, source, parentCls, parentSource, relatedChemicals = [],
}) {
  const iconDisclose = open ? closeIcon : openIcon;
  const altText = open ? 'close details' : 'open details';

  let moreUrl = makeMoreUrl(source.id, source.objCls, relatedChemicals);
  const recConfig = {
    implications,
    text,
    moreText,
    genotypes,
    phenotypes,
    lookupKey,
    classification,
    population,
    alternateDrugAvailable,
    dosingInformation,
    otherPrescribingGuidance,
  };
  let annLinkText;
  if (parentCls === Types.pGxAssociation.displayType) {
    annLinkText = 'see full table…';
    recConfig.populationTitle = 'Affected Subgroup';
    recConfig.recommendationTitle = 'Description of Interaction';
  } else {
    annLinkText = 'read full annotation…';
    const searchParams = new URLSearchParams(window.location.search);
    moreUrl += `?gsi=${searchParams.get('q')}`;
  }

  return (
    <div className="mb-3">
      <div style={{display: 'grid', gridTemplateColumns: 'fit-content(2em) 1fr'}}>
        <div className="mr-1">
          <Button actionHandler={() => onOpenChange(id, !open)} iconOnly={true} title={altText}>
            <FontAwesomeIcon icon={iconDisclose} />
          </Button>
        </div>
        {open && (
          <div>
            <RecommendationAnnotation {...recConfig} multipopulation={multiPopulation} parentCls={parentCls} parentSource={parentSource} />
            <Link href={moreUrl} newTab={true}>{annLinkText}</Link>
          </div>
        )}
        {!open && (
          <div>
            {multiPopulation && <small className="font-weight-bold">{population}</small>}
            <RecommendationAnnotationTags
              alternateDrugAvailable={alternateDrugAvailable}
              dosingInformation={dosingInformation}
              otherPrescribingGuidance={otherPrescribingGuidance}
              parentCls={parentCls}
            />
          </div>
        )}
      </div>
    </div>
  );
}
